<template>
  <div class="top-page-solo">
    <ComponentCardV2 
      v-if="schuifwandTypes.length > 0"
      ref="component"
      :data="slidingWallElement"
      :selected="true"
      variantText="Schuifrichting"
      :variantText2 = "selectedWallData ? 'aantal glasplaten (breedte):' : null"
      :variants2="filteredSlidingWalls"
      :cselected="getComponentSelected()"
      :wSelected="selectedWallData"
      :scolor="schuifwandKleur"
      :svariant="schuifwandRichting"
      :svariant2="schuifwandPreference < filteredSlidingWalls.length ? schuifwandPreference : filteredSlidingWalls.length-1"
      @select="changeSelectedComponent($event)"
      @setSchuifwandRichting="setSchuifwandRichting($event)"
      @setSchuifwandKleur="setSchuifwandKleur($event)"
      @setSchuifwandPreference="setSchuifwandPreference($event)"
      :imgUrl="imgUrl"
    />
  </div>

  <span class="compleet-text">Maak uw glazen schuifwand compleet</span>
  <span class="extra-info">Selecteer eerst de glaswand welke u van opties wilt voorzien.</span>
  <span class="extra-info">Hierna klikt u de gewenste opties aan en verschijnt er een groene omlijning om de gekozen optie</span>


  <div class="options-container">
    <slidingWallToggleButton 
      :label="options.tochtborstel.label"
      :image="previewsServer+'/textures/'+options.tochtborstel.uiImage.url"
      :infobox="options.tochtborstel.infobox"
      :enabled="tochtborstelEnabled"
      @toggle="toggleSchuifwandOption('tochtborstel', $event)"
    />

    <slidingWallToggleButton 
      :label="options.meeneemset.label"
      :image="previewsServer+'/textures/'+options.meeneemset.uiImage.url"
      :infobox="options.meeneemset.infobox"
      :enabled="meeneemsetEnabled"
      @toggle="toggleSchuifwandOption('meeneemset', $event)"
    />

    <slidingWallToggleButton 
      :label="options.slotset.label"
      :image="previewsServer+'/textures/'+options.slotset.uiImage.url"
      :infobox="options.slotset.infobox"
      :enabled="slotsetEnabled"
      @toggle="toggleSchuifwandOption('slotset', $event)"
    />

    <slidingWallToggleButton 
      :label="options.funderingskoker.label"
      :image="previewsServer+'/textures/'+options.funderingskoker.uiImage.url"
      :infobox="options.funderingskoker.infobox"
      :enabled="funderingskokerEnabled"
      @toggle="toggleSchuifwandOption('funderingskoker', $event)"
    />

    <slidingWallToggleButton 
      :label="options.schuifwandachtershutter.label"
      :image="previewsServer+'/textures/'+options.schuifwandachtershutter.uiImage.url"
      :infobox="options.schuifwandachtershutter.infobox"
      :enabled="schuifwandachtershutterEnabled"
      @toggle="toggleSchuifwandOption('schuifwandachtershutter', $event)"
    />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import ComponentCardV2 from "@/components/inputs/ComponentCardV2.vue";
import slidingWallToggleButton from "@/components/inputs/SlidingWallToggleButton.vue";

export default {
  components: {
    ComponentCardV2,
    slidingWallToggleButton
  },
  name: "SlidingWalls",

  data () {
    return {
      previewsServer: import.meta.env.VITE_VUE_APP_PREVIEWS_SERVER,
      slidingWallSchuifrichtingen: [],
      slidingWallColors: [],
      slidingWallElement: {
        colors: [],
        variants: [],
        size: 0
      },
      imgUrl: "",

      tochtborstelEnabledRaw: false,
      meeneemsetEnabledRaw: false,
      slotsetEnabledRaw: false,
      funderingskokerEnabledRaw: false,
      schuifwandachtershutterEnabledRaw: false,
    }
  },

  computed: {
    ...mapGetters({
      components: "getSlidingWallComponents",
      selected: 'getSelectedWallComponent',
      selectedSettings: 'getSelectedWallComponentSettings',
      // TODO change names above so they're the same as in SteellookDoors.vue etc
      selectedElement: 'getSelectedElement',
      selectedWall: 'getSelectedWall',
      selectedWallWidth: 'getSelectedWallWidth',
      getMuurInstances: 'getMuurInstances',

      schuifwandTypes: "getSchuifwandTypes",
      schuifwandWidthRanges: "getSchuifwandWidthRanges",

      schuifwandRichting: "getSchuifwandRichting",
      schuifwandKleur: "getSchuifwandKleur",
      schuifwandPreference: "getSchuifwandPreference",
      schuifwandOptions: "getSchuifwandOptionsPublic",

      configSchuifwandOptions: "getConfigSchuifwandOptions"
    }),
    selectedWallData() {
      return this.getMuurInstances.find((muur) => muur.group.uuid === this.selectedWall?.wall?.parent?.parent?.uuid) || this.getMuurInstances.find((muur) => muur.group.uuid === this.selectedWall?.wall?.parent?.uuid)
    },

    filteredSlidingWalls() {
      const allSlidingWalls = JSON.parse(JSON.stringify(this.schuifwandTypes))
      allSlidingWalls.sort((a, b) => a.maximaleBreedte - b.maximaleBreedte)
      if(!this.selectedWallData) return allSlidingWalls
      let filterendSlidingWalls = []
      allSlidingWalls.forEach((type) => {
        if(type.minimaleBreedte <= this.selectedWallWidth && type.maximaleBreedte >= this.selectedWallWidth) {
          if(!filterendSlidingWalls.find(w => w.glasplaatAantal === type.glasplaatAantal && w.glasplaatBreedte === type.glasplaatBreedte)) {
            filterendSlidingWalls.push(type)
          }
        }
      })
      return filterendSlidingWalls
    },

    options () {
      return {
        tochtborstel: this.schuifwandOptions.find(o => o.keyName === 'tochtborstel'),
        meeneemset: this.schuifwandOptions.find(o => o.keyName === 'meeneemset'),
        slotset: this.schuifwandOptions.find(o => o.keyName === 'slot set'),
        funderingskoker: this.schuifwandOptions.find(o => o.keyName === 'funderingskoker'),
        schuifwandachtershutter: this.schuifwandOptions.find(o => o.keyName === 'schuifwand achter shutter')
      }
    },

    tochtborstelEnabled () {
      if (this.selectedWallData) {
        return this.tochtborstelEnabledRaw
      }
      return this.configSchuifwandOptions.tochtborstel
    },

    meeneemsetEnabled () {
      if (this.selectedWallData) {
        return this.meeneemsetEnabledRaw
      }
      return this.configSchuifwandOptions.meeneemset
    },

    slotsetEnabled () {
      if (this.selectedWallData) {
        return this.slotsetEnabledRaw
      }
      return this.configSchuifwandOptions.slotset
    },

    funderingskokerEnabled () {
      if (this.selectedWallData) {
        return this.funderingskokerEnabledRaw
      }
      return this.configSchuifwandOptions.funderingskoker
    },

    schuifwandachtershutterEnabled () {
      if (this.selectedWallData) {
        return this.schuifwandachtershutterEnabledRaw
      }
      return this.configSchuifwandOptions.schuifwandachtershutter
    }
  },

  methods: {

    // changeSelectedComponent (data) {
    // changeSelectedComponent (component) {     
    //   console.log("changeSelectedComponent", component) 
    //   this.imgCode = component.code
    //   // const component = data.component
    //   // const colorIndex = data.colorIndex
    //   // const optionIndex = data.optionIndex

    //   // const settings = {
    //   //   color: colorIndex ? component.colors[colorIndex] : null,
    //   //   option: optionIndex ? component.options[optionIndex] : null,
    //   // }

    //   const sglasType = this.$refs.component.selectedGlasType;
    //   const sVariant = this.$refs.component.selectedVariant;
    //   const sColor = this.$refs.component.selectedColor;
    //   const sOption = this.$refs.component.selectedOption 
    //   const sLastCode = this.$refs.component.lastCodeSelection;
    //   // console.log('component.keyWords',component.keyWords)
    //   const settings = {
    //       glasType: component.glasTypes && component.glasTypes.length>1 ? component.glasTypes[sglasType] : component.glasTypes ? component.glasTypes[0] : null,
    //       variant: component.variants && component.variants.length>1 ? component.variants[sVariant] : component.variants ? component.variants[0] : null,
    //       color: component.colors.length>1 ? component.colors[sColor] : component.colors[0],
    //       option: component.options.length>1 ? component.options[sOption] : component.options[0],
    //       lastCode: sLastCode,
    //       // hasBetonBand depends on keyword "noBetonband"
    //       hasBetonBand: this.checkKeyWords(component.keyWords) // task 1563
    //   }      
    //   // console.log('settings.hasBetonBand',settings.hasBetonBand)
    //   this.$store.dispatch('changeSelectedWallComponent', {component: component, settings: settings})
    // },

    setSchuifwandRichting (schuifrichting) {
      this.$store.dispatch('setSchuifwandRichting', schuifrichting)

      this.setImgUrl()

      if(this.selectedWallData) {
        this.selectedWallData.schuifwandRichting = schuifrichting
        this.selectedWallData.update()
      }
    },

    setSchuifwandKleur (color) {
      this.$store.dispatch('setSchuifwandKleur', color)

      if(this.selectedWallData) {
        this.selectedWallData.schuifwandKleur = color
        this.selectedWallData.update()
      }
    },

    setSchuifwandPreference (preference) {
      const preferenceIndex = this.filteredSlidingWalls.findIndex(w => w.id === preference.id)
      this.$store.dispatch('setSchuifwandPreference', preferenceIndex)

      this.setImgUrl()

      if(this.selectedWallData) {
        this.selectedWallData.schuifwandPreference = preferenceIndex
        this.selectedWallData.update()
      }
    },

    setImgUrl () {
      const chosenShuifwand = this.filteredSlidingWalls[this.schuifwandPreference > this.filteredSlidingWalls.length-1 ? this.filteredSlidingWalls.length-1 : this.schuifwandPreference]
      const matchingPreferences = this.schuifwandTypes.filter(w => 
        w.glasplaatAantal === chosenShuifwand.glasplaatAantal && 
        w.glasplaatBreedte === chosenShuifwand.glasplaatBreedte && 
        w.maximaleBreedte === chosenShuifwand.maximaleBreedte
      )
      this.imgUrl = matchingPreferences.find(p=>p.schuifrichting===this.schuifwandRichting).image
    },

    checkKeyWords(array){
      // betonband visibility should be set to false for the following key word:
      // "noBetonband"
      // where any value other than -1 means that the key word has been found
      if (array && array.indexOf("noBetonband") > -1) { 
        return false; 
      } 
      else {
        return true;
      }
    },

    async getComponents () {
      if (this.components.length === 0) {
        let categories = ['Schuifwand']
        let trueOnline = true

        await this.$store.dispatch('getSlidingWallComponents', {categories: categories, trueOnline: trueOnline})
        await this.$store.dispatch('getSchuifwandTypes')
      }
    },

    getComponentSelected (component) {
      if(this.selectedElement === null) {return false}
      const muur = this.getMuurInstances.find((muur) => muur.group.uuid === this.selectedElement.parent.parent.uuid)
      const muurMetadata = muur.wallButtonIndex[this.selectedElement.metaData.ModelPosition]
      return component === muurMetadata.component
    },

    processSlidingWalls() {
      this.schuifwandTypes.forEach((type) => {
        // schuifrichtingen
        // if(!this.slidingWallSchuifrichtingen.find(r=>r.name == type.schuifrichting)) {
        //   let foundComponent
        //   type.artikelnummers.forEach((artikelnummer) => {
        //     foundComponent = this.components.find((component) => component.id === artikelnummer)
        //     if(foundComponent) {
        //       this.slidingWallSchuifrichtingen.push({
        //         name: type.schuifrichting,
        //         code: foundComponent.code
        //       })
        //     }
        //   })
        // }
        if(!this.slidingWallSchuifrichtingen.includes(type.schuifrichting)) {
          this.slidingWallSchuifrichtingen.push(type.schuifrichting)
        }

        // colors
        type.artikelnummers.forEach((artikelnummer) => {
          const foundComponent = this.components.find((component) => component.id === artikelnummer)
          if(foundComponent) {
            foundComponent.colors.forEach((color) => {
              if(!this.slidingWallColors.find(c=>c.name===color.name)) {
                this.slidingWallColors.push(color)
              }
            })
          }
        })
      })

      this.slidingWallElement.colors = this.slidingWallColors
      if(this.schuifwandKleur == null) {
        // this.$store.dispatch('setSchuifwandKleur', this.slidingWallColors[0])
        // MatZwart kleur is default gezet
        const defaultColor = this.slidingWallColors.find(color => color.name === 'MatZwart')
        this.$store.dispatch('setSchuifwandKleur', defaultColor || this.slidingWallColors[0])

      }
      this.slidingWallElement.variants = this.slidingWallSchuifrichtingen
      if(this.schuifwandRichting == null) {
        this.$store.dispatch('setSchuifwandRichting', this.slidingWallSchuifrichtingen[0])
      }

      if(this.imgUrl == "") {
        this.imgUrl = this.schuifwandTypes[0].image
      }
    },

    toggleSchuifwandOption(optionKey, newValue) {
      this.$store.commit('setConfigSchuifwandOptions', { [optionKey]: newValue })

      this[optionKey+'EnabledRaw'] = newValue

      if(this.selectedWallData) {
        if (!this.selectedWallData.schuifwandOptions) {
          this.selectedWallData.schuifwandOptions = {}
        }
        this.selectedWallData.schuifwandOptions[optionKey] = newValue
        this.selectedWallData.update()
      }
    }
  },

  watch: {
    filteredSlidingWalls: function (newVal) {
      if(this.selectedWallData) {
        this.imgUrl = newVal[(this.schuifwandPreference >= newVal.length ? newVal.length-1 : this.schuifwandPreference)].image
      }
    },

    // selectedWallData: {
    //   handler: function (newVal) {
    //     console.log("boos changed", newVal)
    //     if(newVal) {
    //       this.$store.dispatch('setSchuifwandRichting', newVal.schuifwandRichting)
    //       this.$store.dispatch('setSchuifwandKleur', newVal.schuifwandKleur)
    //       this.$store.dispatch('setSchuifwandPreference', newVal.schuifwandPreference)
    //       this.imgUrl = this.filteredSlidingWalls[(this.schuifwandPreference >= this.filteredSlidingWalls.length ? this.filteredSlidingWalls.length-1 : this.schuifwandPreference)].image
    //     }
    //   },
    //   immediate: true
    // },

    imgUrl: {
      handler: function () {
        const chosenShuifwand = this.filteredSlidingWalls[this.schuifwandPreference > this.filteredSlidingWalls.length-1 ? this.filteredSlidingWalls.length-1 : this.schuifwandPreference]
        const matchingPreferences = this.schuifwandTypes.filter(w => 
          w.glasplaatAantal === chosenShuifwand.glasplaatAantal && 
          w.glasplaatBreedte === chosenShuifwand.glasplaatBreedte && 
          w.maximaleBreedte === chosenShuifwand.maximaleBreedte
        )
        const slidingWall = matchingPreferences.find(p=>p.schuifrichting===this.schuifwandRichting)
        if (slidingWall) {
          slidingWall.artikelnummers.forEach((artikelnummer) => {
            const foundComponent = this.components.find((component) => component.id === artikelnummer)
            if(foundComponent) {
              // Kleuren volgorde omdraaien t.b.v. dat matzwart altijd bovenaan staat
              this.slidingWallColors = foundComponent.colors.slice().reverse()
              this.slidingWallElement.colors = this.slidingWallColors
            }
          })
        }
      },
      immediate: true
    },

    // selectedWallData: {
    //   handler(newVal) {
    //     this.tochtborstelEnabled = newVal.schuifwandOptions.tochtborstel || false
    //     console.log("tochtborstel changed:", newVal)
    //   },
    //   deep: true
    // }
    selectedWallData: {
      handler(newVal) {
        if(newVal) {
          this.$store.dispatch('setSchuifwandRichting', newVal.schuifwandRichting)
          this.$store.dispatch('setSchuifwandKleur', newVal.schuifwandKleur)
          this.$store.dispatch('setSchuifwandPreference', newVal.schuifwandPreference)
          this.imgUrl = this.filteredSlidingWalls[(this.schuifwandPreference >= this.filteredSlidingWalls.length ? this.filteredSlidingWalls.length-1 : this.schuifwandPreference)].image
        }
        if (newVal && newVal.schuifwandOptions) {
          this.tochtborstelEnabledRaw = newVal.schuifwandOptions.tochtborstel
          this.meeneemsetEnabledRaw = newVal.schuifwandOptions.meeneemset
          this.slotsetEnabledRaw = newVal.schuifwandOptions.slotset
          this.funderingskokerEnabledRaw = newVal.schuifwandOptions.funderingskoker
          this.schuifwandachtershutterEnabledRaw = newVal.schuifwandOptions.schuifwandachtershutter
        }
      },
      deep: true,
      immediate: true // Add this to trigger on component mount
    }
  },

  async mounted() {
    if(this.components.length == 0 || this.schuifwandTypes.length == 0) await this.getComponents();
    
    // set slidingwalls colors and variants
    this.processSlidingWalls()

    if (this.selectedElement == null && !this.selectedWallData?.isSteellook) {
      const component = this.components[0]
      const hasBetonBandValue = this.checkKeyWords(component.keyWords)
      const settings = {
        hasBetonBand: hasBetonBandValue
      }
      this.$store.dispatch('changeSelectedWallComponent', {component, settings})
    }

    // if(this.components.length == 0) {
    //   this.getComponents()
    // } else {
    //   // console.log(this.components)
    //   this.changeSelectedComponent({
    //     component: this.components[0], 
    //     colorIndex: 0, 
    //     optionIndex: 0,
    //     variantIndex: 0,
    //     glasTypeIndex: 0
    //   })
    // }
  },
};
</script>

<style lang="scss" scoped>

.steel-page {
  display: grid;
  padding: 25px 0px;
  gap: 16px;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  grid-auto-rows: minmax(min-content, max-content);
}

.top-page-solo {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 16px;
  min-width: 100%;
  
  &-header {
    display: flex;
    flex-direction: column;
    align-items: center; //start; 
  }
}

.options-container {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr; /* 4 equal columns */
  gap: 8px;
  max-width: 100%;
  position: relative;
  overflow: hidden;
}

@media (max-width: 768px) {
  .options-container {
    grid-template-columns: 1fr 1fr 1fr; /* 2 equal columns */
  }
}

.compleet-text {
  font-size: 20px;
  text-align: left;
  margin-top: 16px;
  font-weight: 400;
}

.extra-info {
  font-size: 20px;
  text-align: left;
}

</style>